import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.svg',
  styleUrls: ['./icons.component.scss']
})
export class IconsComponent implements OnInit {

  @Input() icon;

  constructor() { }

  ngOnInit() {
  }

}
